<script setup>
/******************************************************************************
 * component: Header offline notification
 *****************************************************************************/
import SvgIcon from "Components/SvgIcon/SvgIcon.vue";
</script>

<template>
    <aside
        class="offline"
        title="Sie sind offline."
        aria-label="Sie sind offline."
    >
        <svg-icon class="icon" name="offline" />
        <span class="text">Offline</span>
    </aside>
</template>

<style lang="scss" scoped>
aside {
    margin-left: auto;
}

.offline {
    display: flex;
    align-items: center;

    padding: #{get($sizes, "base") * 0.4};

    background: palette("state", "error");
    color: palette("text", "bright");

    @include respond-to("small") {
        gap: #{get($sizes, "base") * 0.4};
    }

    @include respond-to("large") {
        padding: #{get($sizes, "base") * 0.5} get($sizes, "base");
    }
}

.text {
    display: none;

    @include respond-to("small") {
        display: block;
    }
}

.icon {
    width: 20px;
    height: 20px;

    @include respond-to("medium") {
        width: 24px;
        height: 24px;
    }
}
</style>
